var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { ref: "list", class: ["menu", _vm.modificatorClass] },
    _vm._l(_vm.links, function(item, index) {
      return _c(
        "li",
        { key: index, staticClass: "menu__item", on: { click: _vm.hideMenu } },
        [
          _c("BaseLink", {
            staticClass: "menu__link",
            class: [
              _vm.$route.path.includes("/participants-page") &&
                item.href === "/participants-page" &&
                "nuxt-link-active"
            ],
            attrs: { name: item.name, href: "" + item.href }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84c1b710", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84c1b710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/MenuList.vue
// module id = R82+
// module chunks = 4